import { useEffect } from "react";
import styles from "app/components/blur/blur.module.css";
import { StoreMetadata, useAnalytics, WEB_ASSETS, PREMIUM_URL } from "@commons-monorepo/index";

const Blur = ({ storeMetadata }: {storeMetadata: StoreMetadata;}) => {
  const [logEvent] = useAnalytics({ storeMetadata });

  const images = [
  `${WEB_ASSETS}/blur/banner-mobile-{{lng}}.webp`,
  `${WEB_ASSETS}/blur/banner-{{lng}}.webp`];


  const banners = (() => {
    if (storeMetadata?.country.includes("en")) {
      return images.map((image) => image.replace("{{lng}}", "en"));
    }
    if (storeMetadata?.country.includes("pt")) {
      return images.map((image) => image.replace("{{lng}}", "pt"));
    }
    return images.map((image) => image.replace("{{lng}}", "es"));
  })();

  useEffect(() => {
    logEvent("view_screen", {
      event_subtype: "catalogue_blur",
      user_type: "buyer",
      platform: "web"
    });
  }, []);

  return (
    <div className={styles.blurContainer}>
      <div className={styles.blurBox} />
      <div className={styles.blurContent}>
        <a
          href={PREMIUM_URL}
          onClick={() => {
            logEvent("select_banner", {
              event_subtype: "catalogue_blur",
              user_type: "buyer",
              platform: "web"
            });
          }}>

          <div className={styles.body}>
            <img className={styles.mobile} src={banners[0]} alt='Banner' />
            <img className={styles.desktop} src={banners[1]} alt='Banner' />
          </div>
        </a>
      </div>
    </div>);

};

export default Blur;